<input
  class="toggle"
  [ngClass]="{'disabled': disabled}"
  type="checkbox"
  [id]="formId"
  [(ngModel)]="isChecked"
  (change)="onToggle()"
>
<label
  class="label"
  [ngClass]="{'label--no-border': noBorder,
   'disabled': disabled,
    'full-width': fullWidth
  }"
  [for]="formId"
>{{label}}</label>
